//import RSVP from 'rsvp';
//import { run } from '@ember/runloop';
import Service, { service } from '@ember/service';
import Store from '@ember-data/store';
import ContactsCache from './contacts-cache';
import FundsService from './funds-service';
import AbilitiesService from './abilities';

export default class CacheService extends Service {
  @service declare abilities: AbilitiesService;
  @service declare contactsCache: ContactsCache;
  @service declare currentUser: any;
  @service declare fundsService: FundsService;
  @service declare settings: any;
  @service declare storeCache: any;
  @service declare store: Store;

  async unloadAll() {
    this.abilities.unload();
    this.contactsCache.unload();
    this.currentUser.unload();
    this.fundsService.unload();
    this.settings.unload();
    this.storeCache.unload();
    this.store.unloadAll();

    // TODO: eric - this may no longer be needed
    // // temp workaround until this bug is fixed: https://github.com/emberjs/data/issues/4963
    // return new RSVP.Promise((resolve) => {
    //   run.schedule('destroy', this, function () {
    //     resolve();
    //   });
    // });
  }
}
